// extracted by mini-css-extract-plugin
export default {"applicantModal":"ApplicantDetailsModal_applicantModal__nX6cK","open":"ApplicantDetailsModal_open__vMIfC"};